(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-newsletter-v1"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  var forms = document.querySelectorAll('.section-newsletter-v1 form.needs-validation');

  forms.forEach(function (form, index) {

    // Hidden iframe: Mailchimp receives the submission without taking
    // the customer away from the Shopify website.
    var iframeName = 'mailchimp-submit-' + index + '-' + Date.now();
    var iframe = document.createElement('iframe');

    iframe.name = iframeName;
    iframe.style.display = 'none';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);

    // Submit the form into the hidden iframe instead of navigating away.
    form.setAttribute('target', iframeName);

    // Thank-you message appears BELOW the email box after submission.
    var thankYouMessage = document.createElement('div');

    thankYouMessage.className = 'newsletter-thank-you-message';
    thankYouMessage.textContent = 'Thank you for subscribing!';

    thankYouMessage.style.display = 'none';
    thankYouMessage.style.marginTop = '12px';
    thankYouMessage.style.fontWeight = '600';
    thankYouMessage.style.textAlign = 'center';

    form.parentNode.appendChild(thankYouMessage);

    var submitted = false;

    // Mailchimp response has loaded in the hidden iframe.
    // Because the iframe is cross-domain, Shopify cannot read its contents;
    // the form is therefore kept on-page and the confirmation is shown
    // after the Mailchimp response finishes loading.
    iframe.addEventListener('load', function () {
      if (!submitted) return;

      thankYouMessage.style.display = 'block';
      form.reset();
      submitted = false;
    });

    form.addEventListener('submit', function () {
      submitted = true;
      thankYouMessage.style.display = 'none';
    });

  });

});


  } catch(e) { console.error(e); }
})();
})();
